import React from 'react';
import ViewOnlyDialog from '../common-package/ViewOnlyDialog';

interface IDashboardProps {
  label: string;
  open?: boolean;
  onClose: () => void;
  embedUrl: string;
}

const Dashboard: React.FunctionComponent<IDashboardProps> = ({
  label,
  open,
  onClose,
  embedUrl
}) => {
  return (
    <ViewOnlyDialog fullScreen open={!!open} onClose={onClose} title={label}>
      <iframe
        title={label}
        src={embedUrl}
        frameBorder="0"
        width="100%"
        height="2000"
        allowTransparency
        scrolling="no"
      />
    </ViewOnlyDialog>
  );
};

export default Dashboard;
